/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Who the private-programme page is talking to, and where it sends them back.
 */

import type { AccessEventViewerRole } from "@lemonadetraining/contracts";
import type { UserAccess } from "../hooks/useUserAccess";

type Viewer = Pick<
  UserAccess,
  | "displayRole"
  | "isBoxAdmin"
  | "isOwner"
  | "isBoxCoach"
  | "isIndependentCoach"
  | "isLemonadeAdmin"
  | "isSuperAdmin"
>;

/** Router `state.programmeOrigin` values set by the lists that link to a programme. */
export type ProgrammeOrigin = "own-lane" | "lane" | "library";

export const accessEventViewerRole = (viewer: Viewer): AccessEventViewerRole => {
  if (viewer.displayRole) return viewer.displayRole;
  if (viewer.isIndependentCoach) return "independent_coach";
  if (viewer.isLemonadeAdmin || viewer.isSuperAdmin) return "platform_admin";
  return "athlete";
};

export const privateProgrammeBackTarget = (viewer: Viewer): string => {
  // The gym's programs live on the Programming page for its owners, admins and coaches.
  if (viewer.isBoxAdmin || viewer.isOwner || viewer.isBoxCoach) return "/dashboard/programming";
  if (viewer.isIndependentCoach) return "/dashboard/coach-portal";
  return "/dashboard/workout-library";
};

/** A denial reached from the viewer's own lane or library means the rules are wrong. */
export const isExpectedProgrammeOrigin = (state: unknown): boolean => {
  if (!state || typeof state !== "object") return false;
  const origin = (state as { programmeOrigin?: unknown }).programmeOrigin;
  return origin === "own-lane" || origin === "library";
};
